import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function HrmsMenu(){

const MenuCard = ({link,title,icon,color}) => (

<div className="col-xl-3 col-lg-4 col-md-6 mb-4">

<Link to={link} className="menu-link">

<div className="menu-card" style={{borderTop:`4px solid ${color}`}}>

<div className="menu-icon" style={{color:color}}>
<FontAwesomeIcon icon={icon} size="2x"/>
</div>

<p className="menu-title">{title}</p>

</div>

</Link>

</div>

);

return(

<section className="container-fluid mt-4">

<h5 className="menu-section-title">HRMS</h5>

<div className="row">

<MenuCard link="/add-designation" title="Designation" icon="fa-solid fa-id-badge" color="#0d6efd"/>
<MenuCard link="/add-employee" title="Add Employee" icon="fa-solid fa-user-plus" color="#20c997"/>
<MenuCard link="/emp-list" title="Employee List" icon="fa-solid fa-users" color="#6f42c1"/>
<MenuCard link="/salary-list" title="Payslip List" icon="fa-solid fa-money-check-dollar" color="#fd7e14"/>
<MenuCard link="/add-shift" title="Shift List" icon="fa-solid fa-clock" color="#dc3545"/>
<MenuCard link="/emp-rooster" title="Employee Roster" icon="fa-solid fa-calendar-days" color="#0dcaf0"/>
<MenuCard link="/emp-leave" title="Employee Leave" icon="fa-solid fa-plane-departure" color="#6610f2"/>

</div>

</section>

)

}

export default HrmsMenu;